import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

export interface ConfirmParams {
	title: string;
	title_html?: string;
	message: string;
	inner_message?: string;

	ok_button?: string;
	cancel_button?: string;

	input?: {
		label: string;
		value?: string;
		type?: string;
		placeholder?: string;
		required?: boolean;
		pattern?: RegExp;
	}

	reduce_title_size: boolean,
	reduce_button_size?: boolean,

	dont_show_again_checkbox?: boolean,
	agreement_checkbox?: boolean,
	dont_show_again?: boolean,
	custom_checkbox_label?: string,
	custom_checkbox_value?: boolean,

	before_return?: (ConfirmParams) => Observable<any>;
}

@Component({
	selector      : 'confirm-modal',
	templateUrl   : './confirm.modal.html',
	encapsulation : ViewEncapsulation.None,
	styleUrls     : ['./confirm.modal.scss']
})
export class ConfirmModal implements OnInit {

	public in_process = false;
	public agreement = true;

	constructor(public modal: NgbActiveModal)
	{
	}

	public static get default(): ConfirmParams
	{
		return {
			title                    : 'Are you sure?',
			title_html               : null,
			message                  : '',
			inner_message            : '',
			ok_button                : 'Confirm',
			cancel_button            : 'Cancel',
			input                    : null,
			reduce_title_size        : false,
			reduce_button_size       : false,
			dont_show_again_checkbox : false,
			agreement_checkbox       : false,
			dont_show_again          : false,
			custom_checkbox_label    : '',
			custom_checkbox_value    : false
		};
	}

	private _params: ConfirmParams = ConfirmModal.default;

	get params(): ConfirmParams
	{
		return this._params;
	}

	@Input()
	set params(value: ConfirmParams)
	{
		this._params = value;
	}

	get isInputValid(): boolean
	{
		const input = this._params.input;

		if (!input) return true;

		const value = (input.value || '').trim();

		if (!value) return !input.required;

		return !input.pattern || input.pattern.test(value);
	}

	ngOnInit(): void
	{
		this.in_process = false;
		if (this._params.agreement_checkbox) this.agreement = false;
	}

	close(): void
	{
		if (!this._params.before_return) {
			this.modal.close(this._params);
			return;
		}

		this.in_process = true;
		this._params.before_return(this._params).subscribe(() => {
			this.modal.close(this._params);
		}, () => {
			this.in_process = false;
		});
	}
}
